import { Controller } from "@hotwired/stimulus"

let turnstileLoading

// api.js only auto-renders widgets the first time it runs in a document, so it
// is loaded once in explicit mode and each widget is rendered on connect. That
// keeps the widget working across Turbo visits, which never reload the document.
function loadTurnstile(url) {
  turnstileLoading ||= new Promise((resolve, reject) => {
    const script = document.createElement("script")

    script.src = url
    script.async = true
    script.onload = () => resolve(window.turnstile)
    script.onerror = () => {
      turnstileLoading = undefined
      script.remove()
      reject(new Error("Turnstile script failed to load"))
    }

    document.head.appendChild(script)
  })

  return turnstileLoading
}

export default class extends Controller {
  static values = { scriptUrl: String, sitekey: String, theme: String }

  async connect() {
    const turnstile = await loadTurnstile(this.scriptUrlValue)

    if (!this.element.isConnected || this.widgetId) return

    this.widgetId = turnstile.render(this.element, { sitekey: this.sitekeyValue, theme: this.themeValue })
  }

  disconnect() {
    if (!this.widgetId) return

    window.turnstile.remove(this.widgetId)
    this.widgetId = undefined
  }
}
